module.exports = __webpack_public_path__ + "3d3846a067747ef5094159aca4897d81.png";